import moment from 'moment';
import * as flights from '../flights';
import * as api from '../api';
import * as utils from '../utils';

export class AviasalesInjectService {
    private adultPassengersCount = 0;
    private childPassengersCount = 0;
    private infantPassengersCount = 0;

    private passengers: any[] = [];

    private countries: api.Destination[] = [];

    // Called by Aviasales application to detect if passengers form is available.
    public getNumberOfPassengers() {
        return [this.adultPassengersCount, this.childPassengersCount, this.infantPassengersCount];
    }

    // Called by Aviasales to send passengers data to our form. Reassigned in FlightBookingControl.
    // externalUsers = [{
    //  "birthDate":"28.06.1986",
    //  "lastName":"IVANOV",
    //  "passExpDate":"18.02.2014",   // passport expiry date
    //  "age":"adult",                // "child", "infant"
    //  "firstName":"IVAN",
    //  "gender":"male",              // "female"
    //  "countryName":"Россия",
    //  "passNumber":"92837456",
    //  "country":"RU"                // ISO Alpha-2 country code
    //}, {...}]
    public fill(externalUsers) {
        console.log('AviasalesInject: processing passengers...');

        if (externalUsers && externalUsers.length > 0) {
            const sortedExternalUsers: any[] = [];

            // Sort according to our passenger order
            externalUsers.forEach((externalUser) => {
                if (externalUser.age === 'adult') {
                    sortedExternalUsers.push(externalUser);
                }
            });
            externalUsers.forEach((externalUser) => {
                if (externalUser.age === 'child') {
                    sortedExternalUsers.push(externalUser);
                }
            });
            externalUsers.forEach((externalUser) => {
                if (externalUser.age === 'infant') {
                    sortedExternalUsers.push(externalUser);
                }
            });

            for (let i = 0; i < externalUsers.length; i++) {
                const externalUser = externalUsers[i];
                const passenger = this.passengers[i];

                if (passenger
                    && externalUser.age === passenger.type) {
                    this.fillPassenger(externalUser, passenger);
                }
            }
        }
    }

    private fillPassenger(externalUser: any, passenger: flights.PassengerModel) {
        const docPeriodConstrains = passenger.validationConstraints[passenger.documentType].constraints
            .find((constrain) => constrain.nameProperty === 'ValidityPeriodOfDocument');

        try {
            if (externalUser.birthDate) passenger.birthday = moment(externalUser.birthDate, 'DD.MM.YYYY').format('YYYY-MM-DD');
            if (externalUser.lastName) passenger.lastName = externalUser.lastName;
            if (externalUser.firstName) passenger.firstName = externalUser.firstName;
            if (externalUser.gender) passenger.gender = externalUser.gender;
            if (externalUser.passNumber) passenger.documentNumber = externalUser.passNumber;
            if (externalUser.passExpDate && docPeriodConstrains) passenger.documentValidTill = moment(externalUser.passExpDate, 'DD.MM.YYYY').format('YYYY-MM-DD');
            if (externalUser.country && this.countries) {
                const country = utils.find(this.countries,
                    (c: api.Destination) => {
                        return c.iataCode === externalUser.country;
                    });
                if (country) {
                    passenger.citizenship = parseInt(country.uniqueId);
                }
            }
        } catch (ex) {
            console.error(ex);
        }
    }

    public resetPassengers() {
        this.passengers = [];
        this.adultPassengersCount = 0;
        this.childPassengersCount = 0;
        this.infantPassengersCount = 0;
    }

    // Set passenger count to notify externalo Aviasales script that users can be filled.
    public setPassengers(passengers: flights.PassengerModel[], countries: api.Destination[]) {
        this.passengers = passengers;

        this.countries = countries;

        this.adultPassengersCount = 0;
        this.childPassengersCount = 0;
        this.infantPassengersCount = 0;

        this.passengers.forEach((p: flights.PassengerModel) => {
            if (p.type === 'adult') {
                this.adultPassengersCount++;
            }
            else if (p.type === 'child') {
                this.childPassengersCount++;
            }
            else if (p.type === 'infant') {
                this.infantPassengersCount++;
            }
        });
    }
}
